module.exports = __webpack_public_path__ + "static/media/julesCoffretMob.cd4a91ba.png";